import React, { useEffect, useState } from 'react';
import {
  ManageContainer,
  ManageWrapper,
  MemberContainer,
  ManageHeader,
} from './manageNftsElements';
import LoadingSection from '../Loading';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';

// Tables
import NftsTable from '../../Utils/table/nftsManageTable';

const ManageNftsSection = () => {
  const axiosPrivate = useAxiosPrivate();

  const [loading1, setLoading1] = useState(true);
  const [nfts, setNfts] = useState({});

  useEffect(() => {
    axiosPrivate.get('/getNfts', {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then((res) => {
      setNfts(res.data.nfts);
      setLoading1(false);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  return (
    <ManageContainer>
      <ManageWrapper>
        {loading1 ? (
          <LoadingSection isSmall />
        ) : (
          <MemberContainer>
            <ManageHeader>NFT List</ManageHeader>
            <ManageHeader>{`Total ${nfts.length} NFTs`}</ManageHeader>
            <NftsTable
              data={nfts}
              setData={setNfts}
              rowsPerPage={10}
            />
          </MemberContainer>
        )}
      </ManageWrapper>
    </ManageContainer>
  );
};

export default ManageNftsSection;
